import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { InternalProjectComponent } from './internal-project.component';
import { InternalProjectDetailComponent } from './internal-project-detail.component';
import { InternalProjectListComponent } from './internal-project-list.component';
import { MaterialModule } from '../material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    RouterModule
  ],
  declarations: [InternalProjectComponent, InternalProjectDetailComponent, InternalProjectListComponent]
})
export class InternalProjectModule { }



// WEBPACK FOOTER //
// ./src/app/internal-project/internal-project.module.ts